import { useSyncExternalStore } from "react";

/**
 * UP13 — the Room Rail's compact mode (upstream #9417, #11525 re-created):
 * a per-viewer latch, like the dock's width, kept in device storage. Compact
 * rows stand 36px and carry status, PR badge and time under the label; the
 * arrangement never changes, only the row's presentation.
 */
export const ROOM_RAIL_COMPACT_STORAGE_KEY = "cleo:room-rail:compact";
const event = "cleo-room-rail-compact";
// When device storage refuses (private mode, quota), the latch still holds
// for this page's life so the toggle never feels dead.
let fallback = false;
function read(): boolean {
  try {
    const stored = window.localStorage.getItem(ROOM_RAIL_COMPACT_STORAGE_KEY);
    return stored === null ? fallback : stored === "1";
  } catch {
    return fallback;
  }
}
function subscribe(listener: () => void) {
  window.addEventListener(event, listener);
  window.addEventListener("storage", listener);
  return () => {
    window.removeEventListener(event, listener);
    window.removeEventListener("storage", listener);
  };
}
export function setRoomRailCompact(next: boolean): void {
  fallback = next;
  try {
    window.localStorage.setItem(ROOM_RAIL_COMPACT_STORAGE_KEY, next ? "1" : "0");
  } catch {
    /* viewer preference: the in-memory latch above still holds */
  }
  window.dispatchEvent(new Event(event));
}
export function useRoomRailCompact(): readonly [boolean, (next: boolean) => void] {
  const compact = useSyncExternalStore(subscribe, read, () => false);
  return [compact, setRoomRailCompact] as const;
}
